<template>

    <div class="row statistics-charts-row">

        <div class="col-12 col-md-6">
            <analysis-chart-component
                :chart-data="wasteStreamsChartData"
                :options="wasteStreamsChartOptions"
            ></analysis-chart-component>
        </div>

        <div class="col-12 col-md-6">
            <analysis-chart-component
                :chart-data="materialsChartData"
                :options="materialsChartOptions"
            ></analysis-chart-component>
        </div>

    </div>

</template>

<script>
import AnalysisChartComponent from '../chart/AnalysisChartComponent'
import ChartMixin from '../../mixins/ChartMixin'

export default {
    name: 'DashboardChartsComponent',
    mixins: [ChartMixin],
    components: { AnalysisChartComponent },

    computed: {

        wasteStreamsChartData () {
            let wasteStreamsData = chartData.types

            delete wasteStreamsData.divertedFromLandfill

            return this.analysisChartData(wasteStreamsData, 'value')
        },

        materialsChartData () {
            return this.analysisChartData(chartData.materials, 'value')
        }

    }
}
</script>
